export default {
  connectWallet: "ウォレットの接続",
  disconnect: "切断",
  connected: "接続されました",
  wrongNetwork: "間違ったネットワーク",
  switchNetworks: "ネットワークの切り替え",
  chainNetwork: "{{ CHAIN }} ネットワーク",
  copyToClipboard: "クリップボードにコピー",
  copyCode: "コードをコピー",
  moreInformation: "詳細情報",
  back: "戻る",
  close: "閉じる",
  or: "または",
  more: "その他",
  tryAgain: "再試行",
  tryAgainQuestion: "もう一度試しますか？",
  dontHaveTheApp: "アプリをお持ちではありませんか？",
  scanTheQRCode: "QR コードをスキャン",
  useModal: "モーダルを使用",
  installTheExtension: "拡張機能をインストール",
  getWalletName: "{{ CONNECTORNAME }} を取得",
  otherWallets: "その他のウォレット",
  learnMore: "詳細情報",
  getWallet: "ウォレットを入手",
  approveInWallet: "ウォレットで承認",
  confirmInWallet: "ウォレットで確認",
  awaitingConfirmation: "確認を待っています",
  signIn: "サインイン",
  signOut: "サインアウト",
  signedIn: "サインインしました",
  signedOut: "サインアウトしました",
  walletNotConnected: "ウォレットが接続されていません",

  warnings_walletSwitchingUnsupported: `お使いのウォレットは、このアプリからのネットワークの切り替えをサポートしていません。`,
  warnings_walletSwitchingUnsupportedResolve: `代わりにウォレット内からネットワークを切り替えてみてください。`,
  warnings_chainUnsupported: `このアプリは、現在接続されているネットワークをサポートしていません。`,
  warnings_chainUnsupportedResolve: `切り替えるか切断して続行します。`,

  onboardingScreen_heading: `ウォレットを入手`,
  onboardingScreen_h1: `Web3 の探索を開始`,
  onboardingScreen_p: `ウォレットは、web3 の探索を可能にする魔法のテクノロジーであるイーサリアムのすべてへのゲートウェイです。`,
  onboardingScreen_ctaText: `最初のウォレットを選択してください`,
  onboardingScreen_ctaUrl: `https://ethereum.org/ja/wallets/find-wallet/`,

  aboutScreen_heading: `ウォレットについて`,
  aboutScreen_a_h1: `デジタル資産用`,
  aboutScreen_a_p: `ウォレットを使用すると、NFT やその他のイーサリアム トークンなどのデジタル資産を送信、受信、保存、および操作できます。`,
  aboutScreen_b_h1: `より良いログイン方法`,
  aboutScreen_b_p: `最新のアプリでは、パスワードを覚える必要がなく、ウォレットを簡単なログイン方法として使用できます。`,
  aboutScreen_c_h1: `web3 の世界を探索`,
  aboutScreen_c_p: `ウォレットは、急速に進化する web3 の世界を探索し、参加するために不可欠なユーティリティです。`,
  aboutScreen_ctaText: `詳細情報`,
  aboutScreen_ctaUrl: `https://ethereum.org/ja/wallets/`,

  connectorsScreen_heading: `ウォレットの接続`,
  connectorsScreen_newcomer: `ウォレットを持っていません`,
  connectorsScreen_h1: `ウォレットとは何ですか？`,
  connectorsScreen_p: `ウォレットは、デジタル資産の送信、受信、および保存に使用されます。 ウォレットを接続すると、アプリとやり取りできます。`,

  mobileConnectorsScreen_heading: `ウォレットを選択`,

  scanScreen_heading: `電話でスキャンする`,
  scanScreen_heading_withConnector: `{{ CONNECTORNAME }}でスキャンする`,
  scanScreen_tooltip_default: `携帯電話で {{ CONNECTORNAME }} を 開いてスキャンします`,

  downloadAppScreen_heading: `{{ CONNECTORNAME }} を取得`,
  downloadAppScreen_iosAndroid: `携帯電話のカメラでスキャンして、iOS または Android にダウンロードします。`,
  downloadAppScreen_ios: `携帯電話のカメラでスキャンして、iOS にダウンロードします。`,
  downloadAppScreen_android: `携帯電話のカメラでスキャンして、Android にダウンロードします。`,

  injectionScreen_unavailable_h1: `サポートされていないブラウザ`,
  injectionScreen_unavailable_p: `{{ CONNECTORSHORTNAME }} ウォレットを接続するには、{{ SUGGESTEDEXTENSIONBROWSER }} に拡張機能をインストールします。`,

  injectionScreen_install_h1: `{{ CONNECTORNAME }} をインストール`,
  injectionScreen_install_p: `{{ CONNECTORSHORTNAME }} ウォレットを接続するには、ブラウザ拡張機能をインストールします。`,

  injectionScreen_connecting_h1: `接続を要求`,
  injectionScreen_connecting_p: `{{ CONNECTORSHORTNAME }} ブラウザ拡張機能を 開いて、ウォレットを接続します。`,
  injectionScreen_connecting_injected_h1: `接続を要求`,
  injectionScreen_connecting_injected_p: `このアプリに接続するには、ウォレットを介して要求を受け入れます。`,

  injectionScreen_connected_h1: `すでに接続済み`,
  injectionScreen_connected_p: `このポップアップを閉じてもかまいません`,

  injectionScreen_rejected_h1: `要求がキャンセルされました`,
  injectionScreen_rejected_p: `要求をキャンセルしました。上をクリックしてもう一度お試しください。`,

  injectionScreen_failed_h1: `接続に失敗しました`,
  injectionScreen_failed_p: `申し訳ありませんが、問題が発生しました。もう一度接続してみてください。`,

  injectionScreen_notconnected_h1: `{{ CONNECTORNAME }} にログイン`,
  injectionScreen_notconnected_p: `続行するには、 {{ CONNECTORNAME }} 拡張機能にログインしてください。`,

  profileScreen_heading: "接続されました",

  switchNetworkScreen_heading: "ネットワークの切り替え",

  signInWithEthereumScreen_tooltip:
    "このアプリにサインインしていません。\n続行するには、**イーサリアムでサインイン**してください。",
  signInWithEthereumScreen_signedOut_heading: "イーサリアムでサインイン",
  signInWithEthereumScreen_signedOut_h1:
    "このアプリは、あなたがこのウォレットの 所有者であることを確認しようとしています。",
  signInWithEthereumScreen_signedOut_p: `続行するには、ウォレットで メッセージ リクエストに署名してください。`,
  signInWithEthereumScreen_signedOut_button: "サインイン",

  signInWithEthereumScreen_signedIn_heading: "イーサリアムでサインインしました",
  signInWithEthereumScreen_signedIn_h1:
    "このウォレットの所有者であることが 正常に確認されました。",
  signInWithEthereumScreen_signedIn_p: `サインアウトすると、今後 再度認証する必要があります。`,
  signInWithEthereumScreen_signedIn_button: "サインアウト",
};
